<template>
  <div class="page">
    <div class="app-container">
      <BaseSearch
        v-model="searchData"
        :formOptions="searchFormOption"
        @handleSearch="handleSearch"
      >
      </BaseSearch>
      <el-button type="primary" @click="handleExport"
        ><i class="el-icon-download"></i> 导出</el-button
      >
      <BaseTable
        ref="baseTable"
        url="/admin/CensusReport/backDetail"
        :tableData.sync="tableData"
        :searchParams="searchData"
        :columns="columns"
        :paramsCepCallback="paramsCepCallback"
      >
      </BaseTable>
    </div>
  </div>
</template>

<script>
import { searchFormOption } from "./formOptions";
import { columns } from "./columns";

export default {
  name: "cdtj",
  comments: {},
  data() {
    return {
      tableData: [],
      orgOption: [],
      searchData: {
        date: [],
      },
    };
  },
  computed: {
    columns,
    searchFormOption,
  },
  created() {
    this.getOrg();
  },
  methods: {
    getOrg() {
      this.$api.post("/admin/org/index", {}).then((res) => {
        this.orgOption = res?.data?.data;
      });
    },
    add() {},
    edit(row) {
      console.log(row);
    },
    del(row) {
      console.log(row);
    },
    // 点击搜索
    handleSearch() {
      this.$refs.baseTable.searchData();
    },
    async handleExport() {
      const res = await this.$api.post(
        "/admin/CensusReport/backDetail",
        { is_export: 1, ...this.searchData },
        "导出"
      );
      console.log(res);
      window.open("https://" + res.data);
    },
    // 搜索参数拦截
    paramsCepCallback(params) {
      const beginTime = params.date ? params.date[0] : '';
      const endTime = params.date ? params.date[1] : '';

      return {
        ...params,
        beginTime,
        endTime,
      };
    },
  },
};
</script>
